module.exports = __webpack_public_path__ + "b1233d94f21fcd7d1e3226207b3b3361.png";


//////////////////
// WEBPACK FOOTER
// ./web/images/icons/archive.png
// module id = 610
// module chunks = 0